import { z } from 'zod';
import { useCallback } from 'react';
import { useApi, fetchApiRef } from '@backstage/frontend-plugin-api';
import { checkHistoryResponseSchema } from '../schemas/checks';
import {
  PULSE_CACHE_KEYS,
  PULSE_QUERY_CACHE_POLICIES,
  useCachedQuery,
} from './cache';

export type CheckHistoryPoint = z.infer<
  typeof checkHistoryResponseSchema
>['history'][number];

export const useCheckHistory = (checkId: string, days: number) => {
  const fetchApi = useApi(fetchApiRef);

  const fetchHistory = useCallback(async () => {
    const response = await fetchApi.fetch(
      `plugin://pulse/checks/${encodeURIComponent(
        checkId,
      )}/history?days=${days}`,
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch check history: ${response.status} ${response.statusText}`,
      );
    }

    const data = await response.json();
    const parsed = checkHistoryResponseSchema.parse(data);
    return parsed.history;
  }, [checkId, days, fetchApi]);

  return useCachedQuery({
    cacheKey: PULSE_CACHE_KEYS.checkHistory(checkId, days),
    fetcher: fetchHistory,
    ...PULSE_QUERY_CACHE_POLICIES.history,
  });
};
